import LogRocket from "logrocket"
import { getHostInfo } from "utils/networking"

export const APP_IDS = {
  PROD: "1xqmnl/dashfuel-prod",
  DEV: "1xqmnl/dashfuel-dev",
} as const

export function getLogRocketEnv() {
  const { env } = getHostInfo()
  const isProd = env === "prod"
  const isStaging = env === "staging" || env === "dev"
  const isDebugging = process.env["REACT_APP_DEBUG_LOGROCKET"] === "true"

  return { isProd, isStaging, isDebugging }
}

/**
 * Determine if LogRocket should be enabled based on the environment.
 * Returns true for production, staging, and local environments when debugging is enabled.
 */
export function isLogRocketEnabled() {
  const { isProd, isStaging, isDebugging } = getLogRocketEnv()
  return isProd || isStaging || isDebugging
}

/**
 * Get the correct LogRocket App ID based on environment
 */
export function getLogRocketAppId() {
  const { isProd } = getLogRocketEnv()
  return isProd ? APP_IDS.PROD : APP_IDS.DEV
}

/**
 * Initialize LogRocket for error tracking and session replay
 */
export function useLogRocket() {
  if (!isLogRocketEnabled()) {
    return
  }

  const { isStaging, isDebugging } = getLogRocketEnv()
  const appId = getLogRocketAppId()

  LogRocket.init(appId)

  if (isStaging || isDebugging) {
    console.log(
      `%c LogRocket initialized in dev/staging mode`,
      "background: #764abc; color: white; padding: 4px 8px; border-radius: 4px;"
    )
  }
}
